import { getDefaultData } from './get-default-data';
import { navigation } from '@exploration/cms-constants';

const cmsData = getDefaultData();

const footerText = {
  title: cmsData?.text?.[navigation.footer_links.footer_top_title],
};

export const footerData = {
  footerText,
};
